module.exports = __webpack_public_path__ + "img/CreditType.57554cf2.png";